// import { createCsrfTokenHeaders } from 'utils/http';
import { CONSOLE_REQUEST_ENABLE } from '../../../config/app';

/**
 * 附加公共请求参数
 * @param requestObj
 */
export const requestSuccessFnForAppendage = (requestObj) => {
  // const csrfTokenHeaders = createCsrfTokenHeaders();
  // 使用此方法此方法旨在处理 headers 可能为 undefined 的情况
  // eslint-disable-next-line prefer-object-spread
  // requestObj.headers = Object.assign({}, requestObj.headers, csrfTokenHeaders);
  // eslint-disable-next-line prefer-object-spread
  requestObj.headers = Object.assign({}, requestObj.headers);
  return requestObj;
};

export const requestSuccessFn = (requestObj) => {
  // 打印请求参数
  // eslint-disable-next-line
  CONSOLE_REQUEST_ENABLE &&
    // eslint-disable-next-line no-console
    console.info('requestInterceptorFn', `url:${requestObj.url}`, requestObj);

  // 自定义请求拦截逻辑，可以处理权限，请求发送监控等
  // ...
  // 处理 api 重复配置

  // 添加 token
  // requestObj.headers.Authorization = getToken();

  return requestObj;
};

export const requestFailFn = (error) => {
  // 自定义发送请求失败逻辑，断网，请求发送监控等
  console.log('error', error);

  return Promise.reject(error);
};
